import * as React from 'react';
import { Overline, useDeviceType } from '@cian/ui-kit';
import cx from 'clsx';
import { ContactName } from './ContactName';
import * as styles from './styles.module.css';

/**
 * Компонент для указания основной информации о контакте
 *
 * Адаптивный
 * В малой (до 374px) мобильной версии не выводятся иконки около имени,
 * а все элементы выстраиваются вертикально и центрируются
 */
export function ContactMainInfo(_ref) {
  var title = _ref.title,
      name = _ref.name,
      href = _ref.href,
      target = _ref.target,
      onNameClick = _ref.onNameClick,
      nameIcons = _ref.nameIcons,
      NameHeadingComponent = _ref.NameHeadingComponent,
      vertical = _ref.vertical;
  var deviceType = useDeviceType();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['container'], deviceType === 'phone' && styles['mobile'], vertical && styles['vertical'])
  }, /*#__PURE__*/React.createElement(Overline, {
    color: "gray60_100",
    display: "block"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles['name-container']
  }, /*#__PURE__*/React.createElement(ContactName, {
    as: NameHeadingComponent,
    href: href,
    target: target,
    onClick: onNameClick
  }, name), nameIcons && /*#__PURE__*/React.createElement("div", {
    className: styles['name-icons']
  }, nameIcons)));
}